const AWSFileViewer = ({publication_data}) => {
  return (
    <>
         {publication_data?.publication_type === "image" && (
                        <img
                            src={publication_data?.file}
                            alt={publication_data?.name}
                            className="w-full h-full object-cover"
                        />
                    )}
                    {publication_data?.publication_type === "pdf" && (
                        <iframe
                            src={`${publication_data?.file}#toolbar=0`}
                            title={publication_data?.name}
                            className="w-full h-full object-cover"
                            allowFullScreen={true}
                        />
                    )}
                    {publication_data?.publication_type === "doc" && (
                        <iframe
                            src={`https://docs.google.com/gview?url=${publication_data?.file}&embedded=true`}
                            title={publication_data?.name}
                            className="w-full h-full"
                            
                        />

                    )}
                    {publication_data?.publication_type === "video" && (
                        <video
                            src={publication_data?.file}
                            controls
                            className="w-full h-full object-cover"
                        />
                    )}
                    {publication_data?.publication_type === "audio" && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <audio src={publication_data?.file} controls className="w-full  rounded-[15px] w-full object-contain" />
                        </div>

                    )}
                    {publication_data?.publication_type === 'code' && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <a
                                href={publication_data?.file} // creates local preview URL
                                //   download={file.name} // optional: lets user download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline"
                            >
                                {publication_data?.file}
                            </a>
                        </div>
                    )}
                    </>
  )
}

export default AWSFileViewer